import { Component, Input } from '@angular/core';
import { ContentService } from 'src/app/services/content.service';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-model-component',
  templateUrl: './model-component.component.html',
  styleUrls: ['./model-component.component.scss'],
})
export class ModelComponentComponent {
  @Input() component: any;
  @Input() mode: string = 'player';
  viewer: any;

  constructor(
    public statesService: StatesService,
    public contentService: ContentService
  ) {}
  ngOnInit(): void {}
}
